import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { UserIdService } from '../../auth';
import { SiteFamilyConfig } from '../../model';
import { SiteFamilyConfigFacade } from '../facades';
import { UserActions } from '../store/actions';
import { SiteFamilyConfigSelectors } from '../store/selectors/user.selectors';
import { StateWithUser } from '../store/user-state';

@Injectable()
export class SiteFamilyConfigService implements SiteFamilyConfigFacade {
  constructor(private store: Store<StateWithUser>, private userIdService: UserIdService) {}

  private load(): void {
    this.userIdService.takeUserId().subscribe(
      (userId) => this.store.dispatch(new UserActions.LoadSiteFamilyConfig(userId)),
      () => {}
    );
  }

  getSiteFamilyConfig(): Observable<SiteFamilyConfig | undefined> {
    return this.store.pipe(
      select(SiteFamilyConfigSelectors.getSiteFamilyConfigLoaderState),
      filter((loaderState) => {
        if (this.needsToLoad(loaderState)) {
          this.load();
          return false;
        }
        return loaderState.success;
      }),
      map((loaderState) => loaderState.value)
    );
  }

  getSiteFamilyConfigLoading(): Observable<boolean> {
    return this.store.pipe(select(SiteFamilyConfigSelectors.getSiteFamilyConfigLoading));
  }

  getSiteFamilyConfigLoaded(): Observable<boolean> {
    return this.store.pipe(select(SiteFamilyConfigSelectors.getSiteFamilyConfigLoaded));
  }

  private needsToLoad(loaderState: StateUtils.LoaderState<SiteFamilyConfig>) {
    return !loaderState.success && !loaderState.error && !loaderState.loading;
  }
}
